module.exports = __webpack_public_path__ + "media/images/flags/64/Norway-eef634cc572993ed4b4d6c6be2dde0e5.png";